import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type Theme } from './ThemeProvider';

/** Compact access to the same persisted preference used throughout the app. */
export function ThemeSelect() {
  const { theme, setTheme } = useTheme();
  const Icon = theme === 'system' ? Monitor : theme === 'dark' ? Moon : Sun;
  return (
    <label className="ds-theme-select" title="Tema interfeței">
      <Icon size={18} strokeWidth={1.8} aria-hidden="true" />
      <select aria-label="Tema interfeței" value={theme} onChange={event => setTheme(event.target.value as Theme)}>
        <option value="light">Deschisă</option>
        <option value="dark">Închisă</option>
        <option value="system">Sistem</option>
      </select>
    </label>
  );
}
